import type { z } from 'zod';

import type { TokenSchema } from '../constants/schema';

type AuthenticatedUser = z.infer<typeof TokenSchema>;

/**
 * A profile is complete once it carries both a birthdate and a phone number.
 * Admin-created accounts (e.g. Wakala investors) start without them (TT-137);
 * the completion gate uses this to decide whether to force /complete-profile.
 *
 * Kept as a pure, dependency-light helper so it can be unit-tested and imported
 * without pulling in the auth store / env.
 */
export const isProfileComplete = (user: AuthenticatedUser | undefined): boolean =>
  Boolean(user?.birthdate?.length && user?.phone_number?.length);
